export default __webpack_public_path__ + "static/media/16-bottom.a98879a7.png";